import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function CeLogo() {
  return (
    <div className="w-10 h-10 rounded-xl bg-brand-500 shadow-lg flex items-center justify-center overflow-hidden shrink-0"
      style={{ background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)' }}>
      <svg viewBox="0 0 40 40" className="w-10 h-10">
        {/* C harfi */}
        <path
          d="M22 12 A10 10 0 1 0 22 28"
          fill="none"
          stroke="white"
          strokeWidth="3.5"
          strokeLinecap="round"
        />
        {/* E harfi */}
        <line x1="24" y1="13" x2="32" y2="13" stroke="white" strokeWidth="3" strokeLinecap="round"/>
        <line x1="24" y1="20" x2="30" y2="20" stroke="white" strokeWidth="3" strokeLinecap="round"/>
        <line x1="24" y1="27" x2="32" y2="27" stroke="white" strokeWidth="3" strokeLinecap="round"/>
        <line x1="24" y1="13" x2="24" y2="27" stroke="white" strokeWidth="3" strokeLinecap="round"/>
      </svg>
    </div>
  );
}

export default function HomePage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gray-800 flex justify-center">
    <div className="w-full max-w-md min-h-screen bg-gray-900 flex flex-col relative overflow-hidden">

      {/* Hero — ürün görseli */}
      <div className="relative w-full" style={{ height: '52vw', maxHeight: 340, minHeight: 200 }}>
        <img
          src="/hero.png"
          alt="CE Takip"
          className="w-full h-full object-cover"
        />
        {/* Karartma gradyanı */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-gray-900" />

        {/* Logo üst sol */}
        <div className="absolute top-4 left-4 flex items-center gap-3">
          <div className="bg-white rounded-xl px-2 py-1 shadow-lg">
            <img src="/sisecam-logo.png" alt="Şişecam" className="h-10 w-auto" />
          </div>
          <div className="drop-shadow">
            <span className="text-white font-black text-lg tracking-tight leading-none">CE</span>
            <span className="text-brand-400 font-semibold text-lg tracking-tight leading-none">Takip</span>
          </div>
        </div>
      </div>

      {/* Alt kart alanı */}
      <div className="flex-1 px-4 pt-5 pb-10 space-y-4 -mt-6 relative z-10">

        {/* Karşılama */}
        <div className="mb-1">
          {user?.full_name && (
            <p className="text-gray-400 text-sm">Merhaba, <span className="text-white font-medium">{user.full_name}</span></p>
          )}
          <p className="text-gray-500 text-xs mt-0.5">Devam etmek için bir modül seçin</p>
        </div>

        {/* Satış Takip */}
        <button
          type="button"
          onClick={() => navigate('/satis')}
          className="w-full text-left rounded-2xl overflow-hidden bg-white/10 border border-white/10 backdrop-blur-sm active:scale-[0.98] transition-transform"
        >
          <div className="flex items-stretch">
            {/* Sol renk şeridi */}
            <div className="w-1.5 bg-brand-500 shrink-0 rounded-l-2xl" />
            <div className="flex items-center gap-4 px-4 py-4 flex-1">
              {/* İkon */}
              <div className="w-11 h-11 rounded-xl bg-brand-500/20 border border-brand-500/30 flex items-center justify-center shrink-0">
                <svg className="w-6 h-6 text-brand-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
                    d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-white font-semibold text-base">Satış Takip</p>
                <p className="text-gray-400 text-xs mt-0.5">İş kayıtları · Müşteriler · Raporlar · İzin</p>
              </div>
              <svg className="w-4 h-4 text-gray-500 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>
        </button>

        {/* Toplantı Takip — Yakında */}
        <div className="w-full rounded-2xl overflow-hidden bg-white/5 border border-white/8 cursor-not-allowed select-none">
          <div className="flex items-stretch">
            <div className="w-1.5 bg-gray-600 shrink-0 rounded-l-2xl" />
            <div className="flex items-center gap-4 px-4 py-4 flex-1">
              <div className="w-11 h-11 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center shrink-0">
                <svg className="w-6 h-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <p className="text-gray-500 font-semibold text-base">Toplantı Takip</p>
                  <span className="text-[10px] font-bold uppercase tracking-wide text-gray-600 bg-white/8 border border-white/10 rounded-full px-2 py-0.5">
                    Yakında
                  </span>
                </div>
                <p className="text-gray-600 text-xs mt-0.5">Bu modül henüz kullanıma açılmadı</p>
              </div>
            </div>
          </div>
        </div>

        {/* Operasyon Takip — Yakında */}
        <div className="w-full rounded-2xl overflow-hidden bg-white/5 border border-white/8 cursor-not-allowed select-none">
          <div className="flex items-stretch">
            <div className="w-1.5 bg-gray-600 shrink-0 rounded-l-2xl" />
            <div className="flex items-center gap-4 px-4 py-4 flex-1">
              <div className="w-11 h-11 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center shrink-0">
                <svg className="w-6 h-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
                    d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <p className="text-gray-500 font-semibold text-base">Operasyon Takip</p>
                  <span className="text-[10px] font-bold uppercase tracking-wide text-gray-600 bg-white/8 border border-white/10 rounded-full px-2 py-0.5">
                    Yakında
                  </span>
                </div>
                <p className="text-gray-600 text-xs mt-0.5">Bu modül henüz kullanıma açılmadı</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    </div>
  );
}
